import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useIsMobile } from 'hooks/useIsMobile';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import { useLogout } from 'hooks/useLogin';
import { useHistory } from 'react-router-dom';

export function MenuCredito() {
    const telefono = decodeStorage('telefono_usuario');
    const { isMobile } = useIsMobile();
    const { logOut } = useLogout();
    const history = useHistory();

    const sears_numero_internet = decodeStorage('sears_numero_internet');
    const cardending = decodeStorage('cardending')
    const montoCredito = decodeStorage("montoCredito");
    const creditoDisponible= decodeStorage("creditoDisponible");
    const estadoCredito = decodeStorage("estadoCredito");

    const clickToPay = () => {
        // console.log('clickToPay ElegirPlan')
        encodeStorage('clickToPay', "ElegirPlan")
    }

    return (
        <>
            {isMobile
                ? isMobile === 'desktop' &&
                <nav className="menuCredito">
                    {sears_numero_internet && estadoCredito === 200
                        ? <ul className="ulMiCredito">
                            <li className="opc borderB">
                                <a href={`${BASE_PATH}mi-cuenta/mis-pedidos/dias=30/pagina=1`}>Mis pedidos</a>
                            </li>
                            <li className="opc">
                                <NavLink to={`${BASE_PATH}${SUB_DIRECTORY}home`} activeClassName="active" className={history.location.pathname.includes("home") ? "active" : ""}>&nbsp;Mi crédito Claroshop</NavLink>
                            </li>
                            <li className="opc interna">
                                <NavLink onClick={clickToPay} to={`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`} activeClassName="active" className={history.location.pathname.includes("pagar/") ? "active" : ""}>&nbsp;&nbsp;&nbsp;Pagar</NavLink>
                            </li>
                            <li className="opc interna">
                                <NavLink to={`${BASE_PATH}${SUB_DIRECTORY}movimientos/movimientos-tarjeta`} activeClassName="active" className={history.location.pathname.includes("movimientos/") ? "active" : ""}>&nbsp;&nbsp;&nbsp;Movimientos</NavLink>
                            </li>
                            <li className="opc interna">
                                <NavLink to={`${BASE_PATH}${SUB_DIRECTORY}estado-cuenta/solicitar-estado-cuenta`} activeClassName="active">&nbsp;&nbsp;&nbsp;Estado de Cuenta</NavLink>
                            </li>
                            <li className="opc borderB borderT">
                                <a href={`${BASE_PATH}mi-cuenta/listadeseos/`}>Lista de deseos</a>
                            </li>
                            <li className="opc borderB">
                                <a href={`${BASE_PATH}mi-cuenta/direcciones-envio/`}>Mis direcciones</a>
                            </li>

                            <li className="opc" onClick={logOut}><a className='p'>Cerrar sesión</a></li>
                        </ul>

                        : <ul className="ulMiCredito">
                            <li className="opc borderB">
                                <a href={`${BASE_PATH}mi-cuenta/mis-pedidos/dias=30/pagina=1`}>Mis pedidos</a>
                            </li>
                            <li className="opc">
                                <NavLink to={`${BASE_PATH}${SUB_DIRECTORY}home`} activeClassName="activoPadre" className={(history.location.pathname.includes("home") || history.location.pathname.includes("solicitud-credito-claroshop") || history.location.pathname.includes("beneficios")) ? "activoPadre" : ""}>Mi crédito Claroshop</NavLink>
                            </li>

                            {history.location.pathname.includes("solicitud-credito-claroshop/formulario") && !creditoDisponible && !montoCredito &&
                                <li className="opc interna">
                                    <NavLink to={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/formulario`} activeClassName="active" className={"active"}>&nbsp;&nbsp;&nbsp;Solicita tu Crédito</NavLink>
                                </li>
                            }

                            <li className="opc borderB borderT">
                                <a href={`${BASE_PATH}mi-cuenta/listadeseos/`}>Lista de deseos</a>
                            </li>
                            <li className="opc borderB">
                                <a href={`${BASE_PATH}mi-cuenta/direcciones-envio/`}>Mis direcciones</a>
                            </li>

                            <li className="opc" onClick={logOut}><a className='p'>Cerrar sesión</a></li>
                        </ul>
                    }
                </nav>
                : null
            }
        </>
    )
}